import React, { useEffect, useState } from "react";
// import Navbar from "../components/Navbar";

import axios from "axios";
// import Delivery from "./Delivery";
import { DeliveryList } from "../components/lists/DeliveryList";
import PromoItemList from "../components/lists/PromoItemList";
import { ServiceList } from "../components/lists/ServiceList";

// import { Alert } from "@mui/material";
// import PromoCard from "../components/cards/PromoCard";
import Loading from "../components/Loading";
import { test_ip } from "../services/constants";

import { Line, Circle } from "rc-progress";
import { useDispatch } from "react-redux";
import { setError } from "../services/actions";

function Home(props) {
  const [delivery_list, setDelivery_list] = useState([]);
  const [service_list, setService_list] = useState([]);
  const [promoItem, setPromoItems] = useState([]);

  const [lat, setLat] = useState(null);
  const [lon, setLon] = useState(null);
  const user = JSON.parse(localStorage.getItem("user"));
  // const token = user.server_token;
  const country = user.country_id;
  // const [error, setError] = useState([])
  const [loading, setLoading] = useState([false, false]);
  const dispach = useDispatch();
  // console.log(user,'this is user')

  // var getLocation = function async() {
  //   if (!navigator.geolocation) {
  //     console.log("errorrrrrrr");
  //     // setError(['location not supported'])
  //     // dispach(setError())
  //   } else {
  //     navigator.geolocation.getCurrentPosition((pos) => {
  //       console.log("errorrrrrrr222222", pos);
  //       var latt = pos.coords.latitude;
  //       var lonn = pos.coords.longitude;
  //       if (latt && lonn) {
  //         localStorage.setItem("lat", latt);
  //         localStorage.setItem("lon", lonn);
  //         setLat(latt);
  //         setLon(lonn);
  //       }
  //       console.log(lat, lon);
  //     });
  //   }
  // };

  var Get_Service_List = function (data) {
    // console.log("requesting with", data);
    var body = {
      country: data.country,
      country_code: data.country_code,
      longitude: data.longitude,
      latitude: data.latitude,
      delivery_type: 2,
    };
    body = JSON.stringify(body);
    axios
      .post(`${test_ip}api/user/get_delivery_list_for_nearest_city`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success == true) {
            var city_data = {
              // small data but you can always add more
              city_id: res.data.city._id,
              city_name: res.data.city.city_name,
            };
            localStorage.setItem("city_id", city_data.city_id);
            // var delivery_list = res.data.deliveries;
            var services = res.data.deliveries;
            console.log("delveries_with_courier");

            const Courier = services.filter(
              (service) => service._id === "60f83c2d884dac2155afe254"
            );
            console.log(Courier);
            setService_list(Courier);

            // setService_list(services);
            // setError('')
            var temp = new Object(loading);
            temp[2] = true;
            setLoading(temp);
          } else {
            // console.log(res.data.error_code)
            // console.log(res.data)
            dispach(
              setError({
                error: true,
                message: `error,pleasesss check ${res.data.error_code}`,
              })
            );

            // setError(['some type of error occured with response'])
          }
        } else {
          // do something
          // console.log(res)
          dispach(
            setError({ error: true, message: "Error on request,please reload" })
          );

          // setError(['some type of eroor occured with request'])
        }
      })
      .catch((err) => {
        // do something
        // console.log(err)
        dispach(
          setError({ error: true, message: "Error on request,please reload" })
        );
        // setError(['some type of eroor occured with request'])
      });
  };
  var Get_Delivery_list = function (data) {
    // console.log("requesting with", data);
    var body = {
      country: data.country,
      country_code: data.country_code,
      longitude: data.longitude,
      latitude: data.latitude,
      // delivery_type: 2,
    };
    body = JSON.stringify(body);
    axios
      .post(`${test_ip}api/user/get_delivery_list_for_nearest_city`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success == true) {
            console.log("delveries");
            console.log(res.data);
            var city_data = {
              // small data but you can always add more
              city_id: res.data.city._id,
              city_name: res.data.city.city_name,
            };
            localStorage.setItem("city_id", city_data.city_id);
            var delivery_list = res.data.deliveries;
            // var delivery_list = res.data.city.deliveries;
            setDelivery_list(delivery_list);
            // setError('')
            var temp = new Object(loading);
            temp[0] = true;
            setLoading(temp);
          } else {
            // console.log(res.data.error_code)
            // console.log(res.data)
            dispach(
              setError({
                error: true,
                message: `error,please check ${res.data.error_code}`,
              })
            );

            // setError(['some type of error occured with response'])
          }
        } else {
          // do something
          // console.log(res)
          dispach(
            setError({ error: true, message: "Error on request,please reload" })
          );

          // setError(['some type of eroor occured with request'])
        }
      })
      .catch((err) => {
        // do something
        // console.log(err)
        dispach(
          setError({ error: true, message: "Error on request,please reload" })
        );
        // setError(['some type of eroor occured with request'])
      });
  };
  var Get_Promotion_Items = function () {
    axios
      .post(
        `${test_ip}api/user/get_promotion_item`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            let promotion_item = res.data.promotional_items; // array of full item data with additional fields like store_name
            setPromoItems(promotion_item); // put this however you want
            var temp = new Object(loading);
            temp[1] = true;
            console.log("promotionale items");
            console.log(promotion_item);
            setLoading(temp);
          } else {
            console.log(res.data.error_code);
            dispach(
              setError({
                error: true,
                message: "Error on request,please reload",
              })
            );

            // setError(['some type of error occured with response'])
          }
        } else {
          // do something
          dispach(
            setError({
              error: true,
              message: "Error on response,please reload",
            })
          );
          console.log(res);

          // setError(['some type of error occured with request'])
        }
      })
      .catch((err) => {
        // do something
        dispach(
          setError({ error: true, message: "Error on request,please reload" })
        );
        console.log(err);
        // setError(['some type of error occured with response'])
      });
  };
  const getData = function async() {
    var req_data = {
      country: "Ethiopia",
      country_code: country,
      longitude: lon,
      latitude: lat,
    };
    if (lat && lon) {
      Get_Delivery_list(req_data);
      Get_Service_List(req_data);
    }
    Get_Promotion_Items();
  };
  useEffect(() => {
    // const UserLocation = JSON.parse(localStorage.getItem("userLocation"));
    // if (UserLocation.latitude && UserLocation.longitude) {
    //   setLat(UserLocation.latitude);
    //   setLon(UserLocation.longitude);
    // } else {
    //   setLat(8.9992759);
    //   setLon(38.7694349);
    // }
    setLat(8.9992759);
    setLon(38.7694349);
  }, []);
  useEffect(() => {
    getData();
  }, [lat, lon]);

  return (
    <div
      style={{
        backgroundColor: "white",
        // width: "100vw", // Full width of the viewport
        // height: "100vh",
      }}
    >
      {/* {error ? <p>{error}</p> : null} */}
      <div
        style={{
          backgroundColor: "white",

          marginTop: "5px",
          marginBottom: "5px",
          paddingLeft: "8px",
          fontSize: "0.8rem",
        }}
      >
        <h3 style={{ fontSize: "1.2rem", width: "fit-content" }}>
          Hello,{user.first_name}
        </h3>
        <div style={{ fontSize: "0.7rem", width: "75%" }}>
          You are {10 - (user.order_count % 10)} orders away from your next
          delivery cashback
          <Line
            percent={(user.order_count % 10) * 100}
            strokeWidth={4}
            strokeColor="#F12235"
          />{" "}
          {user.order_count % 10} / 10
        </div>
      </div>
      {loading[0] ? (
        <DeliveryList list={delivery_list} />
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "white",
          }}
        >
          {" "}
          <Loading></Loading>
        </div>
      )}
      <div style={{ background: "white" }}>
        <h3
          style={{
            textAlign: "start",
            paddingLeft: "10px",
            paddingTop: "10px",
            paddingBottom: "10px",
            fontSize: "1.2rem",
            margin: "3px",
            width: "fit-content",
          }}
        >
          Special Offers
        </h3>
        {loading[1] ? (
          <PromoItemList promo={promoItem} handleCart={props.handleCart} />
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Loading></Loading>
          </div>
        )}
      </div>
      <div style={{ background: "white" }}>
        <h3
          style={{
            textAlign: "start",
            paddingLeft: "10px",
            paddingTop: "10px",
            paddingBottom: "10px",
            fontSize: "1.2rem",
            margin: "3px",
            width: "fit-content",
          }}
        >
          Courier
        </h3>
        {loading[2] ? (
          <ServiceList service={service_list} />
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Loading></Loading>
          </div>
        )}
      </div>
    </div>
  );
}

export default Home;
